export default {
  state: {
    selection: {},
    defaultSelection: "4248",
    options: [
      {
        id: "s1",
        name: "Links",
        category: "Bedienseite",
        price: 0,
      },
      {
        id: "s2",
        name: "Rechts",
        category: "Bedienseite",
        price: 68,
      },
    ],
  },

  mutations: {
    setSelection(state, selection) {
      state.selection = selection;
    },

    setDefaultSelection(state, defaultSelection) {
      state.defaultSelection = defaultSelection;
    },

    setOptions(state, options) {
      state.options = options;
    },
  },
};
